export default {
  services: {
    name: 'บริการ',
    fields: {
      name: 'บริการ',
      title_th: 'ชื่อบริการ (ไทย)',
      title_en: 'ชื่อบริการ (อังกฤษ)',
      title: 'ชื่อบริการ (ไทย/อังกฤษ)',
      description_th: 'รายละเอียดบริการ (ไทย)',
      description_en: 'รายละเอียดบริการ (อังกฤษ)',
      service_duration: 'ระยะเวลาบริการ (นาที)',
      service_duration_hours: 'ระยะเวลาบริการ (ชั่วโมง)',
      service_duration_minutes: 'ระยะเวลาบริการ (นาที)',
      short_description_th: 'รายละเอียดบริการโดยย่อ (ไทย)',
      short_description_en: 'รายละเอียดบริการโดยย่อ (อังกฤษ)',
      key: 'คีย์',
      type_of_service: { label: 'หมวดหมู่', service: 'บริการ', other_service: 'บริการอื่น ๆ'},
      green_card_description: 'รายละเอียด Green Card',
      red_card_description: 'รายละเอียด Red Card',
      type: { label: 'ประเภท', choices: { normal: 'ปกติ', promotion: 'โปรโมชั่น' } },
      images: 'รูปภาพประกอบ',
      thumbnail: 'รูป thumbnail',
      youtube_link: 'Youtube Link',
      start_date: 'วันที่เริ่มต้น',
      end_date: 'วันที่สิ้นสุด',
    },
    create: { title: 'สร้างบริการ', success: 'สร้างสำเร็จ' },
    edit: { title: 'แก้ไขบริการ', success: 'แก้ไขสำเร็จ' },
    show: { title: 'แสดงบริการ' },
  },
}
